import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { AlertaConfirmDialog } from '../alerta-confirm';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { TamasAlunoService } from '../tamas-aluno.service';

@Component({
  selector: 'app-premium-sobre',
  templateUrl: './premium-sobre.component.html',
  styleUrls: ['./premium-sobre.component.css']
})
export class PremiumSobreComponent implements OnInit , OnDestroy{
  hideCL: boolean = false;
  listaProdutos: any[] = [];
  listaProdutosTermo: any[] = [];
  cidadeAtual: any = '';
  categoriaAtual: any = '';
  nomeCategoria: any = '';
  mUF: any = '';
  mCidade: any = '';
  urlECfoto: any = '';
  arrPlanosPremium: any[] = [];
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router,  public dialog: MatDialog, public tmaService: TamasAlunoService) { }


  ngOnInit() {
    this.tmaService.eventoFS(true);
    this.hideCL = true;
    this.carregarPlanos();
  }

  ngOnDestroy(){
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }

  carregarPlanos() : void{
    this.tmaService.listarPlanosPremium().subscribe((qRes) =>{
      console.log(qRes);
      if(qRes['res'] == 'done'){
        this.arrPlanosPremium = qRes["dadosPP"];
      }
    })
  }

  goAssinar(idplano: any){

    if(!this.tmaService.logado){
      const avisoIC =  this.dialog.open(AlertaConfirmDialog, {
        // width: '250px',
        disableClose: true,
        data: {tituloAlerta: "Aviso",  textoAlerta: "Para assinar um plano você deve estar logado em sua conta", textoCancel: "Cancelar", textoConfirm: "Fazer Login"}
      });
      avisoIC.afterClosed().subscribe((result) =>{
        console.log(result);
        if(result == true){
          this.router.navigate(['/seja-premium/' + idplano]);
          //this.router.navigate(['/autenticar']);
        }
      });
    }
    else{
      //redirect assinar
      this.router.navigate(['/seja-premium/' + idplano]);
    }
  }
  voltar(): void {

    if(this.tmaService.paginaAnterior == "abertura"){
      this.router.navigate(['/abertura']);
    }
    else{
      //this.router.navigate(['/home']);
      if(this.tmaService.logado){
        this.router.navigate(['/home']);
      }
      else{
        this.router.navigate(['/abertura']);
      }
      //this._location.back();
    }
    
  }

}
